import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { generateCompleteAddress, roundToTwo } from "../../function/other";
import { MainContext } from "../../utils/private_routes/PrivateRoutes";
import { ToWords } from "to-words";

type PropType = {
  apiData: any;
  generalSetting: any;
  width?: string;
  boxShadow?: string;
};

const GenerateExpenseDoc: React.FC<PropType> = (props) => {
  const toWords = new ToWords();
  const { setting, documentSetting } = useContext(MainContext);

  const { apiData, generalSetting, width, boxShadow } = props;
  const companyObj = JSON.parse(window.localStorage.getItem("company") || "");

  const taxesWithPercent: any = [];

  const [finalTaxesWithPercent, setFinalTaxesWithPercent] = useState([]);

  const checkItemTax = new Set();

  const fn = {
    calculate: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      if (apiData?.placeOfSupply === companyObj?.state) {
        obj.cgst = roundToTwo(totalTax / 2);
        obj.sgst = roundToTwo(totalTax / 2);
        obj.igst = 0;
        obj.taxinsideState = item?.tax / 2;
      } else {
        obj.cgst = 0;
        obj.sgst = 0;
        obj.igst = roundToTwo(totalTax);
        obj.taxOutsideState = item?.tax;
      }

      return obj;
    },

    calculateIgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.igst = roundToTwo(totalTax);

      return obj.igst;
    },

    calculateSgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.sgst = roundToTwo(totalTax / 2);

      return obj.sgst;
    },

    calculateCgst: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      obj.cgst = roundToTwo(totalTax / 2);

      return obj.cgst;
    },

    calculateTotal: (item: any) => {
      let obj = {
        discount: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxOutsideState: 0,
        taxinsideState: 0,
        total: 0,
      };

      let subTotal = item?.qty * item?.unitQtyPrice;
      obj.discount = subTotal * (item?.discount / 100);

      let totalAfterDiscount = subTotal - obj.discount;

      let totalTax = totalAfterDiscount * (item?.tax / 100);

      if (apiData?.placeOfSupply === companyObj?.state) {
        obj.cgst = roundToTwo(totalTax / 2);
        obj.sgst = roundToTwo(totalTax / 2);
        obj.igst = 0;
        obj.taxinsideState = item?.tax / 2;
        obj.total = obj.cgst + obj.sgst;
      } else {
        obj.cgst = 0;
        obj.sgst = 0;
        obj.igst = roundToTwo(totalTax);
        obj.taxOutsideState = item?.tax;
        obj.total = obj.igst;
      }

      return obj.total;
    },

    calculateTaxes: () => {
      apiData?.items?.forEach((element: any) => {
        if (checkItemTax.has(element.tax)) {
          taxesWithPercent.forEach((taxElement: any) => {
            if (element.tax === taxElement.tax) {
              taxElement.taxableValue =
                element.unitQtyPrice * element.qty -
                roundToTwo(fn.calculate(element).discount);
              taxElement.cgst = taxElement.cgst + fn.calculateCgst(element);
              taxElement.sgst = taxElement.sgst + fn.calculateSgst(element);
              taxElement.igst = taxElement.igst + fn.calculateIgst(element);
              taxElement.total = taxElement.total + fn.calculateTotal(element);
            }
          });
        } else {
          checkItemTax.add(element.tax);

          taxesWithPercent.push({
            taxableValue:
              element.unitQtyPrice * element.qty -
              roundToTwo(fn.calculate(element).discount),
            tax: element.tax,
            cgst: fn.calculateCgst(element),
            sgst: fn.calculateSgst(element),
            igst: fn.calculateIgst(element),
            total: fn.calculateTotal(element),
          });
        }
      });
      setFinalTaxesWithPercent(taxesWithPercent);
    },
  };

  useEffect(() => {
    if (apiData?.items?.length > 0) {
      fn.calculateTaxes();
    }
  }, [apiData]);

  return (
    <>
      <div
        id="content"
        style={{ width: width, margin: "auto", boxShadow: boxShadow }}
        className="doc_wrapper py-3 px-4"
      >
        <div className="text-end font16x600 textColor3">Original Copy</div>
        <div className="container-fluid p-0 mt-3">
          <div className="row">
            <div className="col-5">
              <h3 className="font20x600 textColor3">WaffleBytes</h3>
              <div className="mt-4">
                <p className="mb-0 font12x500 textColor3">
                  {generateCompleteAddress(
                    companyObj?.address,
                    companyObj?.city,
                    companyObj?.state,
                    companyObj?.country,
                    companyObj?.pincode
                  )
                    .filter((item) => item?.length)
                    .join(", ")}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {`${companyObj?.phoneCode} ${companyObj?.phoneNumber}`}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {companyObj?.emailAddress}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  Contact Name: <span>{companyObj?.contactName}</span>
                </p>
                <p className="mb-0 font12x500 textColor3">
                  GSTIN: <span>--</span>
                </p>
              </div>
            </div>
            <div className="col-7">
              <div className="d-flex justify-content-between align-items-center">
                <p className="mb-0 font16x600 textColor3">Expense</p>
                <p className="mb-0 font20x600 textColor3">{apiData?.number}</p>
              </div>
              <div className="mt-3">
                {documentSetting?.expense?.tAD ? (
                  <div
                    className="d-flex justify-content-between align-items-center px-3"
                    style={{
                      backgroundColor: "var(--bg_color2)",
                    }}
                  >
                    <p className="mb-0 text-white font16x500">Amount Due:</p>
                    <p className="mb-0 text-white font16x500">
                      ₹
                      {roundToTwo(
                        apiData?.calculation?.total - apiData?.paidAmount
                      )?.toLocaleString()}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="mt-3"
                  style={{
                    width: "50%",
                    margin: "0 0 0 auto",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">Issue Date:</span>
                    <span className="font12x400 textColor3">
                      {moment(apiData?.createdAt).format(setting?.dateFormat)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">Due Date:</span>
                    <span className="font12x400 textColor3">
                      {moment(apiData?.dueDate).format(setting?.dateFormat)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">
                      Invoice Number:
                    </span>
                    <span className="font12x400 textColor3">
                      {apiData?.invoiceNumber}
                    </span>
                  </div>
                  {/* <div className="d-flex justify-content-between align-items-center">
                    <span className="font12x500 textColor3">Client Reference:</span>
                    <span className="font12x400 textColor3">
                      {apiData?.clientReference?.name}
                    </span>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="mt-3">
              <h3 className="font14x600 textColor3">Vendor</h3>
              <div>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.vendor?.name}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.vendor?.contactNumber}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {generateCompleteAddress(
                    apiData?.vendor?.completeAddress?.address,
                    apiData?.vendor?.completeAddress?.city,
                    apiData?.vendor?.completeAddress?.state,
                    apiData?.vendor?.completeAddress?.country,
                    apiData?.vendor?.completeAddress?.pincode
                  )
                    .filter((item) => item?.length)
                    .join(", ")}
                </p>
                <p className="mb-0 font12x500 textColor3">
                  {apiData?.vendor?.email}
                </p>
                {!(
                  apiData?.vendor?.gstType === "Unregistered Business" ||
                  apiData?.vendor?.gstType === "Consumer (B2C)" ||
                  apiData?.vendor?.gstType === "Overseas (Outside India)"
                ) &&
                  apiData?.vendor?.gstin !== "" && (
                    <p className="mb-0 font12x500 textColor3">
                      GSTIN:{" "}
                      <span className="font12x400">
                        {apiData?.vendor?.gstin}
                      </span>
                    </p>
                  )}
                {apiData?.vendor?.pan !== "" && (
                  <p className="mb-0 font12x500 textColor3">
                    PAN:{" "}
                    <span className="font12x400">{apiData?.vendor?.pan}</span>
                  </p>
                )}
              </div>
            </div>

            <div className="mt-3">
              <table className="doc_table">
                <thead
                  style={{
                    backgroundColor: "var(--bg_color2)",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th scope="col">Item & Description</th>
                    <th scope="col">HSN/SAC</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Price (₹)</th>
                    <th scope="col">Discount (₹)</th>
                    <th>Taxable Value (₹)</th>
                    {apiData?.placeOfSupply === companyObj?.state ? (
                      <>
                        <th scope="col">CGST (₹)</th>
                        <th scope="col">SGST (₹)</th>
                      </>
                    ) : (
                      <th scope="col">IGST (₹)</th>
                    )}
                    <th scope="col">Total (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {apiData?.items?.map((item: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <p className="mb-0 font12x500 textColor2">
                            {item?.name}
                          </p>
                          <p className="mb-0 font10x500 textColor1">
                            {item?.description}
                          </p>
                        </td>
                        <td>{item?.hsnOrsac}</td>
                        <td>{item?.qty}</td>
                        <td>{item?.unitQtyPrice?.toLocaleString()}</td>
                        <td>
                          <p className="mb-0 textColor1">
                            {roundToTwo(fn.calculate(item).discount)}
                          </p>
                          <p className="mb-0 font10x500 textColor1">
                            {`${item?.discount}%`}
                          </p>
                        </td>
                        <td>
                          {(
                            item?.unitQtyPrice * item?.qty -
                            roundToTwo(fn.calculate(item).discount)
                          )?.toLocaleString()}
                        </td>
                        {apiData?.placeOfSupply === companyObj?.state ? (
                          <>
                            <td>
                              <p className="mb-0 textColor1">
                                {roundToTwo(fn.calculate(item).cgst)}
                              </p>
                              <p className="mb-0 font10x500 textColor1">
                                {`${roundToTwo(
                                  fn.calculate(item).taxinsideState
                                )}%`}
                              </p>
                            </td>
                            <td>
                              <p className="mb-0 textColor1">
                                {roundToTwo(fn.calculate(item).sgst)}
                              </p>
                              <p className="mb-0 font10x500 textColor1">
                                {`${roundToTwo(
                                  fn.calculate(item).taxinsideState
                                )}%`}
                              </p>
                            </td>
                          </>
                        ) : (
                          <td>
                            <p className="mb-0 textColor1">
                              {roundToTwo(fn.calculate(item).igst)}
                            </p>
                            <p className="mb-0 font10x500 textColor1">
                              {`${roundToTwo(
                                fn.calculate(item).taxOutsideState
                              )}%`}
                            </p>
                          </td>
                        )}
                        <td>{roundToTwo(item?.total)?.toLocaleString()}</td>
                      </tr>
                    );
                  })}
                  {/* <tr>
                    <td colSpan={3}>
                      {documentSetting?.expense?.pS && signature ? (
                        <div className="d-flex align-items-center">
                          <div className="px-4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}${signature}`}
                              className="img-fluid"
                              width={100}
                              alt=""
                            />

                            <p className="mt-2 mb-0 font10x500">
                              Provider Signature
                            </p>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td colSpan={4}>
                      <div className="d-flex justify-content-end my-2 px-2">
                        <div className="calculation_wrapper">
                          <div className="calculation_field d-flex justify-content-between mb-3">
                            <p className="mb-0 font12x600 textColor3">
                              Subtotal:
                            </p>
                            <p className="mb-0 font12x600 textColor3">
                              {`₹ ${apiData?.calculation?.subTotal}`}
                            </p>
                          </div>

                          {apiData?.placeOfSupply === companyObj?.state ? (
                            <>
                              <div className="calculation_field d-flex justify-content-between mb-3">
                                <p className="mb-0 font12x600 textColor3">
                                  CGST:
                                </p>
                                <p className="mb-0 font12x600 textColor3">
                                  {`₹ ${apiData?.calculation?.cgst}`}
                                </p>
                              </div>
                              <div className="calculation_field d-flex justify-content-between mb-3">
                                <p className="mb-0 font12x600 textColor3">
                                  SGST:
                                </p>
                                <p className="mb-0 font12x600 textColor3">
                                  {`₹ ${apiData?.calculation?.sgst}`}
                                </p>
                              </div>
                            </>
                          ) : (
                            <div className="calculation_field d-flex justify-content-between mb-3">
                              <p className="mb-0 font12x600 textColor3">
                                IGST:
                              </p>
                              <p className="mb-0 font12x600 textColor3">
                                {`₹ ${apiData?.calculation?.igst}`}
                              </p>
                            </div>
                          )}

                          <div className="calculation_field d-flex justify-content-between mb-3">
                            <p className="mb-0 font12x600 textColor3">
                              Discount:
                            </p>
                            <p className="mb-0 font12x600 textColor3">
                              {`- ₹ ${apiData?.calculation?.discount}`}
                            </p>
                          </div>

                          <div className="calculation_field d-flex justify-content-between">
                            <p className="mb-0 font12x600 textColor6">Total:</p>
                            <p className="mb-0 font12x600 textColor6">
                              {`₹ ${apiData?.calculation?.total}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={10}>
                      <div
                        className="pt-3"
                        style={{ width: "70%", marginLeft: "auto" }}
                      >
                        <div className="d-flex justify-content-between mb-3">
                          <p className="mb-0 font12x600 textColor3">
                            Total Taxable Value
                          </p>
                          <p className="mb-0 font12x600 textColor3">
                            {`₹ ${apiData?.calculation?.subTotal}`}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <p className="mb-0 font12x600 textColor3">
                            Total Value (in figure)
                          </p>
                          <p className="mb-0 font12x600 textColor3">
                            {`₹ ${apiData?.calculation?.total}`}
                          </p>
                        </div>
                        {documentSetting?.expense?.tIW ? (
                          <div className="d-flex justify-content-between mb-3">
                            <p className="mb-0 font12x600 textColor3">
                              Total Value (in words)
                            </p>
                            {apiData &&
                            apiData.calculation &&
                            apiData.calculation.total ? (
                              <p className="mb-0 font12x600 textColor3">
                                ₹
                                {toWords.convert(apiData?.calculation?.total, {
                                  ignoreDecimal: true,
                                })}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr> */}
                </tbody>
                <tbody>
                  {finalTaxesWithPercent?.map((element: any, index: any) => {
                    return (
                      <tr key={index}>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border"></td>
                        <td className="no-border text-end d-flex justify-content-between">
                          <p className="mb-0 font12x600 textColor1">
                            {index === 0 ? `Total` : ""}
                          </p>
                          <p className="mb-0 font12x600 textColor1 ms-3">
                            @{element.tax}%
                          </p>
                        </td>
                        <td>{element?.taxableValue?.toLocaleString()}</td>
                        {apiData?.placeOfSupply === companyObj?.state ? (
                          <>
                            <td>{element?.cgst}</td>
                            <td>{element?.sgst}</td>
                          </>
                        ) : (
                          <td>{element?.igst}</td>
                        )}

                        <td>{element?.total?.toLocaleString()}</td>
                      </tr>
                    );
                  })}

                  <tr>
                    <td colSpan={10} className="no-top-border">
                      <div
                        className="py-2"
                        style={{ width: "55%", marginLeft: "auto" }}
                      >
                        {apiData?.calculation?.discount != 0 && (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Discount
                            </p>
                            <p className="mb-0 font12x600 textColor3 text-end">
                              {`₹ ${apiData?.calculation?.discount?.toLocaleString()}`}
                            </p>
                          </div>
                        )}
                        <div className="total-section d-grid justify-content-between mb-1">
                          <p className="mb-0 font12x600 textColor3 text-end">
                            Total Taxable Value
                          </p>
                          <p className="mb-0 font12x600 textColor3 text-end">
                            {`₹ ${(
                              apiData?.calculation?.subTotal -
                              apiData?.calculation?.discount
                            )?.toLocaleString()}`}
                          </p>
                        </div>
                        <div className="total-section d-grid justify-content-between mb-1">
                          <p className="mb-0 font12x600 textColor3 text-end">
                            Total Value (in figure)
                          </p>
                          <p className="mb-0 font12x600 textColor3 text-end">
                            {`₹ ${apiData?.calculation?.total?.toLocaleString()}`}
                          </p>
                        </div>
                        {documentSetting?.expense?.tIW ? (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Total Value (in words)
                            </p>
                            {apiData &&
                            apiData.calculation &&
                            apiData.calculation.total ? (
                              <p className="mb-0 font12x600 textColor3 text-end">
                                {toWords.convert(apiData?.calculation?.total, {
                                  // ignoreDecimal: true,
                                  currency: true,
                                })}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {documentSetting?.expense?.nRTS ? (
                          <div className="total-section d-grid justify-content-between mb-1">
                            <p className="mb-0 font12x600 textColor3 text-end">
                              Paid Amount
                            </p>
                            <p className="mb-0 font12x600 textColor3 text-end">
                              ₹ {apiData?.paidAmount?.toLocaleString()}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="d-flex justify-content-end gap-2">
                {documentSetting?.expense?.pS &&
                  generalSetting?.primarySignature && (
                    <div>
                      <div className="pt-4 signature-text-container">
                        <div className="signature-container">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}${generalSetting?.primarySignature}`}
                            width={100}
                          />
                        </div>
                        <p className="mt-2 mb-0 font10x500 text-start">
                          {generalSetting?.pSName}
                        </p>
                      </div>
                    </div>
                  )}

                {documentSetting?.expense?.sS &&
                  generalSetting?.secondarySignature && (
                    <div>
                      <div className="pt-4 signature-text-container">
                        <div className="signature-container">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}${generalSetting?.secondarySignature}`}
                            width={100}
                          />
                        </div>
                        <p className="mt-2 mb-0 font10x500 text-start">
                          {generalSetting?.sSName}
                        </p>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateExpenseDoc;
